module.exports = __webpack_public_path__ + "static/media/Brittany Bowman Headshot.ccd2ad2f.jpeg";